import { Heading } from '@chakra-ui/react'
import { H3 } from 'src/typography/typography'

const FormTitle = props => (
  <H3 {...props} />
)

export default FormTitle
